import { useIsActiveStationVideo } from '@app/core/stations/hooks/useIsActiveStationVideo';
import { Box, Skeleton } from '@mui/material';
import Grid from '@mui/material/Grid2';
import {
  FRAGMENT_LIST_CONTAINER_SX,
  FRAGMENTS_GRID_ITEM_PROPS_BY_VIEW_MODE,
  FRAGMENTS_GRID_SKELETON_CARD_COUNT,
  FRAGMENTS_GRID_SPACING,
  FRAGMENTS_LIST_SKELETON_CARD_COUNT,
} from '../../fragment-card/constants';
import { useFragmentGridContext } from '../FragmentGridContext';
import { AudioFragmentCardSkeleton } from './AudioFragmentCardSkeleton';
import { FragmentCardListSkeleton } from './FragmentCardListSkeleton';
import { VideoFragmentCardSkeleton } from './VideoFragmentCardSkeleton';

/**
 * Skeleton shown during initial load. List view: single column; grid view: grid by viewMode.
 */
export function FragmentsGridSkeleton() {
  const isVideo = useIsActiveStationVideo();
  const { viewMode } = useFragmentGridContext();
  const isList = viewMode === 'list';

  return (
    <Box>
      <Box sx={{ mb: 1 }}>
        <Skeleton width="200px" height={24} />
      </Box>
      {isList ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
            ...FRAGMENT_LIST_CONTAINER_SX,
          }}
        >
          {Array.from({
            length: FRAGMENTS_LIST_SKELETON_CARD_COUNT,
          }).map((_, i) => (
            <FragmentCardListSkeleton key={i} />
          ))}
        </Box>
      ) : (
        <Grid container spacing={FRAGMENTS_GRID_SPACING} columns={60}>
          {Array.from({ length: FRAGMENTS_GRID_SKELETON_CARD_COUNT }).map((_, i) => (
            <Grid size={FRAGMENTS_GRID_ITEM_PROPS_BY_VIEW_MODE[viewMode]} key={i}>
              {isVideo ? <VideoFragmentCardSkeleton /> : <AudioFragmentCardSkeleton />}
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}
